import React, { useState } from 'react';
import { InfoIcon } from 'src/assets/icons/InfoIcon';
import { HeaderWrapper, Title, InfoIconWrapper, Tooltip } from './SectionHeader.style';

interface SectionHeaderPropsType {
    title: string;
    tooltip?: string;
}

export const SectionHeader = ({ title, tooltip }: SectionHeaderPropsType): JSX.Element => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <HeaderWrapper>
            <Title>{title}</Title>
            {tooltip !== undefined && (
                <InfoIconWrapper
                    onMouseEnter={(): void => setShowTooltip(true)}
                    onMouseLeave={(): void => setShowTooltip(false)}
                >
                    <InfoIcon />
                    <Tooltip show={showTooltip}>{tooltip}</Tooltip>
                </InfoIconWrapper>
            )}
        </HeaderWrapper>
    );
};
